import type { Theme } from "@mui/material/styles";

import { configureHighchartsDefaults as configure } from "@utilifeed/components/propai/charts";

export function configureHighchartsDefaults(theme: Theme): void {
  configure(theme);
}
